import React, { useState, useEffect, useCallback } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Navigate } from "react-router-dom";

import { showAlert } from "../../../redux/slices/alertSlice";
import { changePasswordUser } from "../../../redux/slices/userSlice";

import "../../../assets/css/forms.css";
import { EyeIcon, EyeSlashIcon } from "../../../components/Icon/icons";
import IconButton from "../../../components/IconButton/IconButton";
import AuthenticationLayout from "../../../components/UI/AuthenticationLayout/AuthenticationLayout";
import ButtonSpinner from "../../../components/UI/ButtonSpinner/ButtonSpinner";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";

function PasswordChangeScreen() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [reNewPassword, setReNewPassword] = useState("");

  const dispatch = useDispatch();
  const userSlice = useSelector((state) => state.userSlice);

  const navigate = useNavigate();
  const goToHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const handleShowAlert = useCallback(
    (alert) => {
      dispatch(showAlert(alert));
    },
    [dispatch]
  );

  const onChangeIsPasswordShown = () => {
    setIsPasswordShown(!isPasswordShown);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(changePasswordUser({ id: userSlice.user.id, newPassword, reNewPassword }));
    setIsSubmitted(true);
  };

  useEffect(() => {
    const canRedirect = isSubmitted && !userSlice.loading && !userSlice.error;
    if (canRedirect) {
      handleShowAlert({
        headingText: "Senha redefinida!",
        text: "Senha redefinida com sucesso!",
      });
      goToHome();
    }
  }, [goToHome, handleShowAlert, isSubmitted, userSlice.error, userSlice.loading]);

  if (!userSlice.user) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Redefinir Senha</title>
        <link rel="stylesheet" href="/bootstrap.alt.css" />
      </Helmet>

      <AuthenticationLayout>
        <div className="authentication-form">
          <h4>{userSlice.user.is_first_login ? "Primeiro Cadastro:" : "Redefinir Senha:"}</h4>

          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="newPassword">
              <Form.Floating className="mb-3">
                <Form.Label>Nova Senha</Form.Label>
                <InputGroup>
                  <Form.Control
                    required
                    type={isPasswordShown ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <IconButton className="form-control-icon" style={{ padding: 0 }} onClick={onChangeIsPasswordShown}>
                    {isPasswordShown ? <EyeIcon /> : <EyeSlashIcon />}
                  </IconButton>
                </InputGroup>
              </Form.Floating>
            </Form.Group>

            <Form.Group controlId="confirmedPassword" className="mb-3">
              <Form.Floating>
                <Form.Label>Repetir Senha</Form.Label>
                <InputGroup>
                  <Form.Control
                    required
                    type={isPasswordShown ? "text" : "password"}
                    value={reNewPassword}
                    onChange={(e) => setReNewPassword(e.target.value)}
                  />
                  <IconButton className="form-control-icon" style={{ padding: 0 }} onClick={onChangeIsPasswordShown}>
                    {isPasswordShown ? <EyeIcon /> : <EyeSlashIcon />}
                  </IconButton>
                </InputGroup>
              </Form.Floating>
            </Form.Group>

            <ButtonSpinner type="submit" isLoading={userSlice.loading}>
              Redefinir Senha
            </ButtonSpinner>
          </Form>
        </div>

        {userSlice.error && <FormAlert alertTextList={userSlice.error} />}
      </AuthenticationLayout>
    </>
  );
}

export default PasswordChangeScreen;
